require('bootstrap');
require('jquery');
window.toastr = require('toastr');

import 'src/admin/components/masks/custom-masks';
import 'src/service_providers/accounts/register';

import './application.scss';

require.context('../../images', true);
